import { useCallback } from 'react'
import {
  getNextAssistantVersionIndex as computeNextAssistantVersionIndex,
  getNextQueryVersionIndex as computeNextQueryVersionIndex,
} from '@/features/chat/exchangeVersionUtils'

/** @param {object} m */
export function useExchangeVersionActions(m) {
  const {
    messagesByThreadId,
    setActiveQueryVersionByExchangeId,
    setActiveAnswerVersionByExchangeId,
  } = m
  const setExchangeActiveQueryVersion = useCallback((exchangeId, nextVersionIndex) => {
    setActiveQueryVersionByExchangeId((prev) => ({ ...prev, [exchangeId]: nextVersionIndex }))
    setActiveAnswerVersionByExchangeId((prev) => {
      const next = { ...prev }
      delete next[exchangeId]
      return next
    })
  }, [setActiveQueryVersionByExchangeId, setActiveAnswerVersionByExchangeId])
  const setExchangeActiveAnswerVersion = useCallback((exchangeId, nextAssistantVersionIndex) => {
    setActiveAnswerVersionByExchangeId((prev) => ({ ...prev, [exchangeId]: nextAssistantVersionIndex }))
  }, [setActiveAnswerVersionByExchangeId])
  const getNextQueryVersionIndex = useCallback(
    (tid, exchangeId) => computeNextQueryVersionIndex(messagesByThreadId, tid, exchangeId),
    [messagesByThreadId],
  )
  const getNextAssistantVersionIndex = useCallback(
    (tid, exchangeId, versionIndex) =>
      computeNextAssistantVersionIndex(messagesByThreadId, tid, exchangeId, versionIndex),
    [messagesByThreadId],
  )
  return {
    setExchangeActiveQueryVersion,
    setExchangeActiveAnswerVersion,
    getNextQueryVersionIndex,
    getNextAssistantVersionIndex,
  }
}
